import React from 'react';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {HashRouter as Router, Switch, Route, Redirect, withRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import AppContainer from './containers/main/app';
import RegisterContainer from './containers/main/register'
import OsContainer from './containers/main/os';
import {primary, secondary} from './styles/colors';
import 'react-toastify/dist/ReactToastify.css';
import 'react-imageslides/lib/index.css';

import {NotificationContainer} from 'components/common/uiKit/notitication';

import {checkUserExist} from 'services/user';
import {loadSettings} from 'services/setting';

import 'animate.css/animate.css'
import 'flag-icon-css/css/flag-icon.min.css';

import store from './services/redux/store';

//const store = configureStore();

const THEME = createMuiTheme({

    palette: {
        primary: {
            main: primary
        },
        secondary: {
            main: secondary
        }
    },
});

class App extends React.Component {
    constructor(props) {
        super(props);
    }

    checkAuth() {
        const userExist = checkUserExist();
        if (!userExist) {
            return 'register';
        }

        if (window.location.hash.includes('app/'))
            return window.location.hash.replace('#/', '');

        return 'app';
    }

    loadAppSettings() {
        loadSettings();
    }

    osDetect() {

        const isInWebAppiOS = (window.navigator.standalone === true);
        const isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);

        if (!isInWebAppChrome && navigator.userAgent.match(/Android/i))
            return 'android';
        if (!isInWebAppiOS && navigator.userAgent.match(/iPhone|iPad|iPod/i))
            return 'ios';

        return 'web';

        /*            const android = navigator.userAgent.match(/Android/i);
                const ios = navigator.userAgent.match(/iPhone|iPad|iPod/i);
                debugger;

                const isMobile = {
                    Android: function () {
                        return navigator.userAgent.match(/Android/i);
                    },
                    iOS: function () {
                        debugger;
                        if ('standalone' in navigator && !navigator.standalone && (/iphone|ipod|ipad/gi).test(navigator.platform) && (/Safari/i).test(navigator.appVersion)) {
                            debugger;
                        }
                        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                    },
                    Windows: function () {
                        return navigator.userAgent.match(/IEMobile/i);
                    },
                    any: function () {
                        return (isMobile.Android() || isMobile.iOS() || isMobile.Windows());
                    }
                };
                return isMobile.any();*/
    }

    checkOs() {
        const os = this.osDetect();

        this.loadAppSettings();
        switch (os.toLowerCase()) {
            case 'android':
                return 'os/android';
            case 'ios':
                return 'os/ios';
            default :
                return this.checkAuth();
        }
    }

    render() {

        return (
            <Provider store={store}>
                <MuiThemeProvider theme={THEME}>
                    <NotificationContainer/>
                    <Router>
                        <div id="preloader">
                            <div className="spinner-border color-highlight" role="status"></div>
                        </div>

                        <Switch>
                            <Redirect exact from="/" to={`/${this.checkOs()}`}/>
                            <Route path="/app">
                                <AppContainer/>
                            </Route>
                            <Route path="/register">
                                <RegisterContainer/>
                            </Route>
                            <Route path="/os">
                                <OsContainer/>
                            </Route>
                        </Switch>
                    </Router>
                </MuiThemeProvider>
            </Provider>
        );
    }
}

export default App;


